@if (errorText()) {
  <mat-error class="error-text-message">{{ errorText() }}</mat-error>
}
